////////LIBRARY/////////
import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { bindActionCreators } from 'redux'
import { map, isNull, isEmpty } from 'lodash'
import moment from 'moment'
import { useSelector, shallowEqual, useDispatch } from 'react-redux'
///////COMPONENTS///////
import TableNested from '../../../../components/Table/components/TableNested'
import TelecollectDetailSaleNested from './TelecollectDetailSaleNested'
import { telecollectManagerActionCreators } from '../../../../store/actions'
import { TelecollectDetailSaleStatus, TelecollectDetailSalePaymentStatus } from './TelecollectDetailSaleComponent'

//////STYLED//////
const TelecollectDetailSaleWrapper = styled.div`
	& > span {
		margin-bottom: 20px;
		display: block;
	}
`
//////STYLED//////

const TelecollectDetailSale = (props) => {
	const [inputData, setInputData] = useState([])

	const { translations, user, sale } = useSelector(
		(state) => ({
			translations: state.languages.translations,
			user: state.user,
			sale: state.telecollectManager.sale,
		}),
		shallowEqual
	)

	const actionsTelecollectManager = bindActionCreators(telecollectManagerActionCreators, useDispatch())

	///////////////////////////////// CONFIG ///////////////////////////////////////

	const config = {
		name: '',
		paging: {},
		isInNestedTable: true,
		nestedValues: {
			value: true,
			nestedData: 'salesOrderLines',
			nestedComponent: TelecollectDetailSaleNested,
			defaultVisible: true,
			nestedPointer: 'id', // To retrieve index of line which is nested toggled or not => nestedPointer = nestedPointerValuePath
			nestedPointerValuePath: 'props.row.id', // To retrieve value of line which is nested toggled or not => nestedPointer = nestedPointerValuePath
			toggleAllNestedPointer: 'toggleNested', // Are we seeing nested lines or not
		},
		isInModal: true,
	}

	const columns = [
		{
			dataHook: 'dateCreated',
			headerName: translations['modal__paymentCollectionManagement__admin__detail__salesOrders__salesTable_tableHeader__dateCreated'],
			sortable: true,
			isAuthorize: true,
			component: (props) => (!isNull(props.row.dateCreated) ? moment(props.row.dateCreated).format('DD/MM/YYYY HH:mm') : '-'),
		},
		{
			dataHook: 'idTransaction',
			headerName: translations['modal__paymentCollectionManagement__admin__detail__salesOrders__salesTable_tableHeader__transactionNumber'],
			sortable: true,
			isAuthorize: true,
		},
		{
			dataHook: 'salesOrderType.translationKey',
			headerName: translations['modal__paymentCollectionManagement__admin__detail__salesOrders__salesTable_tableHeader__transactionType'],
			sortable: true,
			isAuthorize: true,
			toTranslate: true,
			toMapObject: true,
		},
		{
			dataHook: 'salesOrderStatus',
			headerName: translations['modal__paymentCollectionManagement__admin__detail__salesOrders__salesTable_tableHeader__transactionStatus'],
			sortable: true,
			isAuthorize: true,
			component: TelecollectDetailSaleStatus,
		},
		{ dataHook: 'paymentStatus', headerName: 'PAIEMENT', sortable: true, isAuthorize: true, component: TelecollectDetailSalePaymentStatus },
		{
			dataHook: 'paymentType.translationKey',
			headerName: translations['modal__paymentCollectionManagement__admin__detail__salesOrders__salesTable_tableHeader__paymentType'],
			sortable: true,
			isAuthorize: true,
			toTranslate: true,
			toMapObject: true,
		},
		{
			dataHook: 'paymentStatus',
			headerName: translations['modal__paymentCollectionManagement__admin__detail__salesOrders__salesTable_tableHeader__buy_cancel'],
			sortable: true,
			isAuthorize: true,
			component: (props) =>
				props.row.paymentStatus.id === 3
					? translations['modal__paymentCollectionManagement__admin__detail__salesOrders__buy_text']
					: translations['modal__paymentCollectionManagement__admin__detail__salesOrders__cancel_text'],
		},
		{
			dataHook: 'transactionTotalAmoutTTC',
			headerName: translations['modal__paymentCollectionManagement__admin__detail__salesOrders__salesTable_tableHeader__transactionAmountTTC'],
			sortable: true,
			isAuthorize: true,
			component: (props) =>
				!isNull(props.row.transactionTotalAmoutTTC)
					? `${props.row.transactionTotalAmoutTTC}${props.row.currency.symbol}`
					: `0${props.row.currency.symbol}`,
		},
	]

	/////////////////////////////// USE EFFECT /////////////////////////////////////

	useEffect(() => {
		const ftl = { kiosksInLocalScope: map(user.identity.kioskSelected, 'id') }
		actionsTelecollectManager.getDetailSale(props.idTelecollect, props.row.id, ftl)
	}, [])

	useEffect(() => {
		setInputData(sale)
	}, [sale])

	///////////////////////////////// RENDER ///////////////////////////////////////

	return (
		<TelecollectDetailSaleWrapper>
			<span>
				{translations['modal__paymentCollectionManagement__admin__detail__salesOrders__text']}{' '}
				{moment(props.row.dateCreated).format('DD/MM/YYYY HH:mm')}
			</span>
			{!isEmpty(inputData) && translations && <TableNested inputColumns={columns} inputData={inputData} inputConfig={config} />}
		</TelecollectDetailSaleWrapper>
	)
}

TelecollectDetailSale.propTypes = {}

TelecollectDetailSale.defaultPropTypes = {}

export default TelecollectDetailSale
